import React, {Suspense} from 'react';
// import PageBouncingLoader from '../../../../stories/pages/ShimmerLoader/PageBouncingLoader/PageBouncingLoader';
import ReviewPageLoaders from '../../../stories/components/hotels/Loadingpage/ReviewPageLoaders/ReviewPageAllLoaders/ReviewPageAllLoaders';
const Component = React.lazy(() => import('./ReviewPage'));

const ReviewPagePageChunk = () => {
  return (
    <Suspense fallback={<ReviewPageLoaders />}>
      <Component />
    </Suspense>
  );
};

export default ReviewPagePageChunk;
